import { render, staticRenderFns } from "./dataDicConfig.vue?vue&type=template&id=22e60a9c&scoped=true&"
import script from "./dataDicConfig.vue?vue&type=script&lang=js&"
export * from "./dataDicConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e60a9c",
  null
  
)

export default component.exports